"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle2"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _formWrapper = require("../../../../reducers/formWrapper.js");
var _assignmentPlansForGroup = _interopRequireDefault(require("./assignmentPlansForGroup.graphql"));
var _AssignmentPlan = _interopRequireDefault(require("./AssignmentPlan"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AssignmentPlans = function AssignmentPlans(props) {
  var displaySettings = props.displaySettings,
    error = props.field.error,
    row = props.row,
    _props$validationSett = props.validationSettings,
    validationSettings = _props$validationSett === void 0 ? {} : _props$validationSett;
  var deploymentHandles = displaySettings.deploymentHandles,
    disableAddAssignmentPlan = displaySettings.disableAddAssignmentPlan,
    groupIdPath = displaySettings.groupIdPath,
    roleHandles = displaySettings.roleHandles;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    plans = _useState2[0],
    setPlans = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deployments = _useState4[0],
    setDeployments = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    planErrors = _useState8[0],
    setPlanErrors = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    groupAndDescendants = _useState0[0],
    setGroupAndDescendants = _useState0[1];

  // dcwDropdown depends on roleDropdown, so can't hide it unless roldDropdown is also hidden
  var isHideRoleDropdown = Array.isArray(roleHandles) && roleHandles.length === 1;
  var isHideDcwDropdown = isHideRoleDropdown && Array.isArray(deploymentHandles) && deploymentHandles.length === 1;

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function getAssignmentPlans() {
      return _getAssignmentPlans.apply(this, arguments);
    }
    function _getAssignmentPlans() {
      _getAssignmentPlans = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var groupId, result, resultPlans, resultDeployments, descendantGroups;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              groupIdPath = groupIdPath || 'group.groupId';
              groupId = row && row[groupIdPath] || 0;
              _context.n = 1;
              return _cccisdApollo.client.query({
                query: _assignmentPlansForGroup["default"],
                variables: {
                  groupId: groupId,
                  deploymentHandles: deploymentHandles
                },
                fetchPolicy: 'network-only'
              });
            case 1:
              result = _context.v;
              resultPlans = (0, _get2["default"])(result, 'data.groups.anyGroup.createdAssignmentPlanList', []).map(function (plan) {
                return _objectSpread(_objectSpread({}, plan), {}, {
                  isExpanded: false,
                  sessions: plan.sessions.map(function (session) {
                    return _objectSpread(_objectSpread({}, session), {}, {
                      isExpanded: false
                    });
                  })
                });
              });
              resultDeployments = (0, _get2["default"])(result, 'data.flows.deploymentList', []);
              if (Array.isArray(deploymentHandles)) {
                resultDeployments = resultDeployments.filter(function (dep) {
                  return deploymentHandles.includes(dep.deploymentHandle);
                });
                if (resultDeployments.length === 0) {
                  console.error('Could not find any deployment with one of the given handles: ' + JSON.stringify(deploymentHandles));
                }
              }
              if (Array.isArray(roleHandles)) {
                resultDeployments = resultDeployments.filter(function (dep) {
                  return roleHandles.includes(dep.roleHandle);
                });
                if (!resultDeployments.some(function (dep) {
                  return (0, _get2["default"])(dep, 'settings.isAssignmentPlanEligible');
                })) {
                  console.error('Could not find any deployments assocaited with the given roles: ' + JSON.stringify(roleHandles));
                }
              }
              descendantGroups = (0, _get2["default"])(result, 'data.groups.anyGroup.descendantGroups.anyGroupList', []) || [];
              updatePlans((0, _cloneDeep2["default"])(resultPlans));
              setDeployments(resultDeployments);
              setGroupAndDescendants([result.data.groups.anyGroup].concat(_toConsumableArray(descendantGroups)));
              setLoading(false);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _getAssignmentPlans.apply(this, arguments);
    }
    getAssignmentPlans();
  }, []);
  (0, _react.useEffect)(function () {
    if (validationSettings.isRequired && plans.filter(function (p) {
      return !p.toDelete;
    }).length === 0) {
      addPlan();
    }
  }, [plans]);
  (0, _react.useEffect)(function () {
    if (error) {
      var newPlanErrors = [];
      plans.forEach(function (_, i) {
        newPlanErrors.push(error["plan".concat(i)]);
      });
      setPlanErrors(newPlanErrors);
    }
  }, [error]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function addPlan() {
    /* if only one handle is specified, we will be hiding
     * dropdown from the UI so we need to set it here
     */
    var role = '';
    if (isHideRoleDropdown) {
      role = roleHandles[0];
    }
    var newPlan = {
      label: '',
      role: role,
      isExpanded: true
    };
    updatePlans([].concat(_toConsumableArray(plans), [newPlan]));
  }

  /**
   * This is the heart of this component tree. Child components use it to set
   * new values to the overall assignmentProgress field.
   * @param {array} updatedPlans The new version of assignmentPlans to set
   */
  function updatePlans(updatedPlans) {
    props.changeAllFields(updatedPlans, props);
    setPlans(updatedPlans);
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: 'form-label' + (validationSettings.isRequired ? ' ' + _style["default"].required : '')
  }, "Assignment Plans:"), /*#__PURE__*/_react["default"].createElement("div", null, plans.map(function (plan, index) {
    return /*#__PURE__*/_react["default"].createElement(_AssignmentPlan["default"], {
      deployments: deployments,
      displaySettings: displaySettings,
      groupAndDescendants: groupAndDescendants,
      index: index,
      isHideDcwDropdown: isHideDcwDropdown,
      isHideRoleDropdown: isHideRoleDropdown,
      key: index,
      plan: plan,
      planError: planErrors[index],
      planErrors: planErrors,
      plans: plans,
      updatePlanErrors: setPlanErrors,
      updatePlans: updatePlans
    });
  })), disableAddAssignmentPlan !== true && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary",
    onClick: addPlan
  }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add Assignment Plan"));
};
AssignmentPlans.propTypes = {
  /**
   * Callback to change the redux value of the field AND all fields that
   * depend on it
   */
  changeAllFields: _propTypes["default"].func,
  displaySettings: _propTypes["default"].shape({
    deploymentHandles: _propTypes["default"].arrayOf(_propTypes["default"].string),
    disableSurveyOverride: _propTypes["default"].bool,
    enableAllowRetakeToggle: _propTypes["default"].bool,
    enableMustTakeInOrderToggle: _propTypes["default"].bool,
    groupIdPath: _propTypes["default"].string,
    hideDatePickers: _propTypes["default"].bool,
    roleHandles: _propTypes["default"].arrayOf(_propTypes["default"].string),
    toggleForRequired: _propTypes["default"].bool
  }),
  /** The redux form fields object */
  field: _propTypes["default"].object.isRequired,
  /** Each appdef field, keyed by handle (needed for changeAllFields) */
  fieldTypes: _propTypes["default"].object,
  /** GraphQL appdef settings */
  graphqlSettings: _propTypes["default"].object,
  isDisabled: _propTypes["default"].bool,
  /** All data loaded from graphql */
  loadedData: _propTypes["default"].object,
  /** 'create' or 'edit' */
  operation: _propTypes["default"].string,
  /** The reduxForm, from mapStateToProps */
  reduxForm: _propTypes["default"].object,
  /**
   * Array of field handles which should be set to the same value as this
   * field, keyed by handles (needed for changeAllFields)
   */
  requiredByFields: _propTypes["default"].object,
  row: _propTypes["default"].object,
  validationSettings: _propTypes["default"].object
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    reduxForm: state.form
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeAllFields: _formWrapper.changeAllFields
})(AssignmentPlans);